import cn from 'classnames';

export const Sidebar = ({ sections = [] }) => {
  return (
    <aside className="flex h-full w-[220px] flex-shrink-0 flex-col overflow-y-auto border-r border-neutral-4 bg-neutral-1 p-4">
      {sections.map((section, sectionIndex) => (
        <div className="mb-6 flex flex-col" key={section.title || sectionIndex}>
          {section.title && (
            <div className="mb-2 px-3 text-lg font-bold uppercase tracking-wide text-neutral-9">
              {section.title}
            </div>
          )}
          {section.items.map(item => {
            return (
              <button
                type="button"
                key={item.id}
                className={cn(
                  'flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-neutral-7 hover:bg-neutral-3',
                  { 'bg-neutral-3 font-semibold': item.active },
                )}
                onClick={item.onClick}>
                <span className="text-[14px]">{item.label}</span>
                {item.count != null && (
                  <span
                    className={cn(
                      'text-neutral-6 text-lg font-semibold bg-grey-2 rounded-full w-8 h-8 flex items-center justify-center',
                      item.active && '!bg-primary-4 text-white',
                    )}>
                    {item.count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      ))}
    </aside>
  );
};
